var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag-status",class:[_vm.type]},[(_vm.icon)?_c('b-icon',{attrs:{"icon":_vm.icon,"size":"is-small"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"tag-status__text"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }